import { replaceUserTimezoneWithUtc } from '@monetize/utils/core';
import { formatISO } from 'date-fns/formatISO';
import { isValid } from 'date-fns/isValid';
import { parseISO } from 'date-fns/parseISO';
import { boolean, nativeEnum, number, object, string, z } from 'zod';

export enum EntityNameEnum {
  ACCOUNT = 'Account',
  CONTRACT = 'Contract',
  CREDIT = 'Credit',
  CREDIT_NOTE = 'CreditNote',
  INVOICE = 'Invoice',
  PAYMENT = 'Payment',
  QUOTE = 'Quote',
  QUOTE_OFFERING = 'QuoteOffering',
  REFUND = 'Refund',
}
export const EntityNameEnumZ = nativeEnum(EntityNameEnum);

export enum EventTypeEnum {
  CREATE = 'Create',
  UPDATE = 'Update',
}
export const EvenyTypeEnumZ = nativeEnum(EventTypeEnum);

export enum IntegrationLogStatusEnum {
  FAILED = 'Failed',
  SUCCESS = 'Successful',
}
export const IntegrationStatusEnumZ = nativeEnum(IntegrationLogStatusEnum);

export const IntegrationLogRequestSchema = z.object({
  limit: z.number(),
  next: z.string().nullish(),
  entityName: z.string().nullish(),
  eventType: z.string().nullish(),
  status: z.string().nullish(),
  fromLastUpdatedAt: z
    .string()
    .refine((val) => isValid(parseISO(val)))
    .transform((val) => (val ? formatISO(replaceUserTimezoneWithUtc(val)) : ''))
    .nullish(),
  toLastUpdatedAt: z
    .string()
    .refine((val) => isValid(parseISO(val)))
    .transform((val) => (val ? formatISO(replaceUserTimezoneWithUtc(val)) : ''))
    .nullish(),
});
export type TIntegrationLogRequestSchema = z.infer<
  typeof IntegrationLogRequestSchema
>;

export const IntegrationLogResSchema = object({
  id: number(),
  entityName: EntityNameEnumZ,
  sourceId: string(),
  sourceSystemId: string(),
  sourceSystemType: string(),
  // The external record's id in the target system. Alphanumeric, not numeric —
  // e.g. a Salesforce 18-char id. The connector types this as `Option<String>`.
  targetId: string().nullish(),
  targetSystemType: string(),
  eventType: EvenyTypeEnumZ,
  eventTimestamp: string(),
  lastUpdatedAt: string(),
  createdAt: string(),
  status: IntegrationStatusEnumZ,
  log: string(),
  label: string(),
  isUnknownError: boolean(),
  errorResponse: string().nullish(),
});
export type IntegrationLogResponse = z.infer<typeof IntegrationLogResSchema>;

export type IntegrationLogTimeStampFilter = {
  fromLastUpdatedAt?: string;
  toLastUpdatedAt?: string;
};

export const IntegrationLogEventPublishResponse = object({
  id: string(),
  entityType: EntityNameEnumZ,
  action: string(),
});

export type IntegrationLogEventPublishReq = z.infer<
  typeof IntegrationLogEventPublishResponse
>;

export const IntegrationLogPublishResponseSchema = object({
  success: boolean(),
  message: string(),
});

export type IntegrationLogEventPublishResponse = z.infer<
  typeof IntegrationLogPublishResponseSchema
>;
